import styled from "styled-components";
import {
  COMMON,
  FLEXBOX,
  LAYOUT,
} from "@sproutsocial/seeds-react-system-props";
import type { TypeIconV2Size } from "./IconTypes";

const dimensions: {
  [key in TypeIconV2Size]: { container: string; icon: string };
} = {
  default: { container: "24px", icon: "18px" },
  small: { container: "20px", icon: "15px" },
};

/**
 * Structural, non-semantic container that centers a caller-supplied SVG inside a
 * fixed-size box (slightly larger than the icon, for breathing room). The child
 * `svg` is sized via CSS to the icon dimensions and inherits color through
 * `currentColor` — no background or border.
 */
const Container = styled.span<{
  iconSize: TypeIconV2Size;
}>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  color: inherit;
  width: ${(props) => dimensions[props.iconSize].container};
  height: ${(props) => dimensions[props.iconSize].container};

  & > svg {
    width: ${(props) => dimensions[props.iconSize].icon};
    height: ${(props) => dimensions[props.iconSize].icon};
    flex-shrink: 0;
    fill: currentColor;
  }

  ${COMMON}
  ${FLEXBOX}
  ${LAYOUT}
`;

export default Container;
